/**
 * Specifies an option instrument's "in the money" condition.
 * tag: 2681
 * @readonly
 * @enum {number} (int)
 */
export enum InTheMoneyCondition {
  StandardITM = 0,
  ATMITM = 1,
  ATMCallITM = 2,
  ATMPutITM = 3,
}
